import { styled } from '@mui/material';

import { Typography, Box, Stack, tokens } from '@cast/design-system';

const Indicator = styled(Box)(() => ({
  width: 8,
  height: 8,
  borderRadius: '2px',
}));

type IndicatorRowProps = {
  name: string;
  color: string;
  border?: string;
};

const IndicatorRow = ({ name, color, border }: IndicatorRowProps) => {
  return (
    <Stack direction="row" gap={8} py={7} alignItems="center">
      <Indicator bgcolor={color} border={border} />
      <Typography
        variant="P12R"
        color={tokens.theme.fg.structural.primaryOnInverse}
      >
        {name}
      </Typography>
    </Stack>
  );
};

export const SavingsTooltip = () => {
  return (
    <>
      <Typography
        variant="P12R"
        color={tokens.theme.fg.structural.primaryOnInverse}
      >
        Shows how monthly costs would change if resource recommendations are
        applied. Recommendations either reduce resources to optimize costs or
        increase them to optimize performance.
      </Typography>
      <Stack bgcolor="grey.700" mx={-8} px={8}>
        <IndicatorRow name="Optimizing costs" color="green.500" />
        <IndicatorRow
          name="Optimizing performance"
          color="black"
          border="grey.400"
        />
      </Stack>
    </>
  );
};
